import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import useUnitManagement from '../useUnitManagement';
import ModalAlertBody from './ModalAlertBody';

const useDeactivateConfirmationModal = (
  unit: NonNullable<UnitListSchemaType['units']>[number],
) => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { toggleUnitStatus } = useUnitManagement();

  const openDeactivateConfirmationModal = () => {
    if (unit.isTemporary || !unit.isActive) {
      toggleUnitStatus(unit.uid);
      return;
    }

    openConfirmModal({
      title: t('pageProperty.units.modals.title'),
      body: <ModalAlertBody type="deactivate" unit={unit} />,
      confirmColor: 'primary',
      confirmLabel: t('pageProperty.units.status.deactivate'),
      onConfirm: () => {
        toggleUnitStatus(unit.uid);
      },
    });
  };

  return { openDeactivateConfirmationModal };
};

export default useDeactivateConfirmationModal;
